module.exports = __webpack_public_path__ + "img/base_restauration_cafeteria.d510961d.svg";